import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { AudienciaDto } from '@models/audiencia/audienciaDto.model';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { A11yModule } from '@angular/cdk/a11y';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { AudienciaFilter } from '@models/audiencia/audienciaFilter.model';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { RegistroContableService } from '@services/registroContable/registroContable.service';
import { TipoRegistroContableService } from '@services/tipoRegistroContable/tipoRegistroContable.service';
import { RegistroContableFilter } from '@models/registroContable/registroContableFilter.model';
import { RegistroContableDto } from '@models/registroContable/registroContableDto.model';
import { DialogFormRegistroContableComponent } from '../dialog-form-registro-contable/dialog-form-registro-contable.component';
import { EstadoRegistroContableService } from '@services/estadoRegistroContable/estadoRegistroContable.service';
import { DtoBase } from '@models/base/dtoBase.model';
import { CuentaContableService } from '@services/cuentaContable/cuentaContable.service';
import { CuentaCajaService } from '@services/cuentaCaja/cuentaCaja.service';
import { CuentaContableDto } from '@models/cuentaContable/cuentaContableDto.model';
import { CuentaCajaDto } from '@models/cuentaCaja/cuentaCajaDto.model';
import { EtiquetasPipe } from '@pipes/etiquetas.pipe';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { BaseDto } from '@models/base/baseDto.model';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';
import { PruebasExpedienteComponent } from '@views/pruebas/pruebaExpediente/pruebas-expediente/pruebas-expediente.component';


@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule, EtiquetasPipe,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatTooltipModule, MatSortModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, MatNativeDateModule, MatSelectModule, MatRadioModule, A11yModule, MatCheckboxModule, AvatarInicialesComponent, BuscarExpedienteComponent, ButtonFilterTableClearComponent,PruebasExpedienteComponent,
  ],
  selector: 'app-list-registro-contable',
  templateUrl: './list-registro-contable.component.html',
  styleUrls: ['./list-registro-contable.component.css']
})



export class ListRegistroContableComponent {

  accionesDialog = AccionesDialog;
  @Input() idExpediente!: number
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<RegistroContableDto>();
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  checkedFiltroAvanzado: boolean = false;
  expedienteDto: any;
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  tiposRegistroContable!: BaseDto[];
  filtro: RegistroContableFilter = new RegistroContableFilter;
  filtroRegistroContableGuardado!: string | null;
  estadosRegistroContable!: DtoBase[];
  cuentasContables!: CuentaContableDto[];
  cuentasCaja!: CuentaCajaDto[];
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }
  constructor(
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private registroContableService: RegistroContableService,
    private tipoRegistroContableService: TipoRegistroContableService,
    private estadoRegistroContableService: EstadoRegistroContableService,
    private cuentaContableService: CuentaContableService,
    private cuentaCajaService: CuentaCajaService

  ) {

    this.formFilter = this.formBuilder.group({
      descripcion: [null],
      IdsTipoRegistroContable: [null],
      IdsEstadoRegistroContable: [null],
      IdExpediente: [null],
      IdsPlanillaCaja: [null],
      IdsCuentaCaja: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      FechaModificacionDesde: [null],
      FechaModificacionHasta: [null],
      FechaBajaDesde: [null],
      FechaBajaHasta: [null],
      FechaDesde: [null],
      FechaHasta: [null],
      EsEditable: [null],
      AprobadoPor: [null],
      IdCuentaContable: [null],
      IdAsientoContable: [null],
      IdRegistroRelacionado: [null],
      IdComprobante: [null]
    });

    this.getAllTiposRegistroContable()
    this.getAllCuentaCaja()
    this.getAllCuentaContable()
    this.getAllEstadosRegistroContable()
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  guardarFiltro() {
    this.filtro = this.formFilter.value;
    localStorage.setItem('filtroRegistroContableGuardado', JSON.stringify(this.filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroRegistroContableGuardado');
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit(): void {

    if (this.idExpediente) {
      this.filtro.idExpediente = this.idExpediente
      this.formFilter.controls['IdExpediente'].setValue(this.idExpediente);
    }


    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      if (this.idExpediente) {
        this.displayedColumns = result.matches ?
          ['fecha', 'tipoRegistroContable', 'aprobadoPor', 'accion'] :
          ['fecha', 'tipoRegistroContable', 'estadoRegistroContable', 'importe', 'etiquetas', 'aprobadoPor', 'estados', 'accion'];

        this.getAllByFilter(this.filtro);
      } else {
        this.displayedColumns = result.matches ?
          ['fecha', 'tipoRegistroContable', 'aprobadoPor', 'accion'] :
          ['fecha', 'tipoRegistroContable', 'estadoRegistroContable', 'importe', 'etiquetas', 'aprobadoPor', 'estados', 'accion'];

      }
    });

    this.filtroRegistroContableGuardado = localStorage.getItem('filtroRegistroContableGuardado');
    if (this.filtroRegistroContableGuardado) {
      this.filtro = JSON.parse(this.filtroRegistroContableGuardado);
      this.formFilter.patchValue(this.filtro);
    }

    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'fecha':
          return item.fecha ?? '';

        case 'estadoRegistroContable':
          return item.estadoRegistroContable?.descripcion?.toLowerCase?.() ?? '';

        case 'planillaCaja':
          return item.planillaCaja?.descripcion?.toLowerCase?.() ?? '';

        case 'importe':
          return item.importe?.toLowerCase?.() ?? '';

        case 'tipoRegistroContable':
          return item.tipoRegistroContable?.descripcion?.toLowerCase?.() ?? '';

        case 'planillaCaja':
          return item.planillaCaja?.descripcion?.toLowerCase?.() ?? '';

        case 'aprobadoPor':
          return item.aprobadoPor?.nombre?.toLowerCase?.() ?? '';

        default:
          return typeof item[property] === 'string'
            ? item[property].toLowerCase()
            : item[property] ?? '';
      }
    };

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }



  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.idExpediente = this.expedienteDto.id
    this.formFilter.controls['IdExpediente'].setValue(this.expedienteDto.id);
  }


  getAll() {
    this.spinner.show('spListado')
    this.registroContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false

        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }


  getAllRegistroContablesByIdExpediente(idExpediente: number) {
    this.spinner.show('spListado')
    this.registroContableService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro(filtro: RegistroContableFilter = this.formFilter.value) {

    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }


  getAllTiposRegistroContable() {
    this.spinner.show('spTiposRegistroContable')
    this.tipoRegistroContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spTiposRegistroContable')
          this.tiposRegistroContable = data
        },
        error => {
          this.spinner.hide('spTiposRegistroContable')
          this.snackBar.showError(error, "Error");
        })
  }
  getAllEstadosRegistroContable() {
    this.spinner.show('spEstadosRegistroContable')
    this.estadoRegistroContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosRegistroContable')
          this.estadosRegistroContable = data
        },
        error => {
          this.spinner.hide('spEstadosRegistroContable')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllCuentaContable() {
    this.spinner.show('spCuentaContable')
    this.cuentaContableService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spCuentaContable')
          this.cuentasContables = data
        },
        error => {
          this.spinner.hide('spCuentaContable')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllCuentaCaja() {
    this.spinner.show('spCuentaCaja')
    this.cuentaCajaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spCuentaCaja')
          this.cuentasCaja = data
        },
        error => {
          this.spinner.hide('spCuentaCaja')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllByFilter(filtro: RegistroContableFilter) {
    this.spinner.show('spRegistroContable')
    this.registroContableService.getAllByFilter(filtro)
      .subscribe(
        data => {
          this.spinner.hide('spRegistroContable')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spRegistroContable')
          this.snackBar.showError(error, "Error");
        })
  }



  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "50%"
        dialogConfig.height = '80%'
        break;
    }

    const dialogRef = this.dialog.open(DialogFormRegistroContableComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
